import * as R from 'ramda'
import { postFilePercentage } from '../../helpers/api/api';
import { call, reducer } from '../../helpers/api/meta';

export const SAVE_WATCHED_VIDEOS = 'SAVE_WATCHED_VIDEOS';

export const callPostFilePercentage = (inputs) => {
  const meta = {
      endpoint: (inputs) => postFilePercentage(inputs),
      inputs,
      action: SAVE_WATCHED_VIDEOS,
      messages: {
          id: 'postWatchedVideo',
          failure: 'Could not send video details'
      }
  }
  return call(meta)
}

const initialState = {
  loading: false,
  result: []
}


const saveWatchedVideos = (state, action) => {
  if (action && action.result) {
    const result = [...state.result, { ...action.result }]
    return R.assoc('result', result, state)
  } else {
    return R.assoc('result', action, state)
  }
}

export default reducer(initialState, SAVE_WATCHED_VIDEOS, saveWatchedVideos)
